import type { Ref } from 'vue';

import { createIdempotencyHeaders, ensureIdempotencySubmission } from '@peanuds/shared';
import type { IdempotencySubmission } from '@peanuds/shared';

type IdempotentOptions<TOptions extends { headers?: object }> = Omit<TOptions, 'headers'> & {
  headers: NonNullable<TOptions['headers']> & ReturnType<typeof createIdempotencyHeaders>;
};

export const withStoreIdempotencyHeaders = <TOptions extends { headers?: object }>(
  lastSubmission: Ref<IdempotencySubmission | null>,
  options: TOptions,
  fingerprint: string,
): IdempotentOptions<TOptions> => {
  const submission = ensureIdempotencySubmission(lastSubmission.value, fingerprint);
  lastSubmission.value = submission;

  return {
    ...options,
    headers: {
      ...options.headers,
      ...createIdempotencyHeaders(submission.key),
    },
  };
};
